var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppNavigationTop',{attrs:{"navigationInfo":_vm.AppNavigationTopInfo}}),_c('DocumentLogListSimple'),_c('v-layout',{staticClass:"mt-4 mb-4",attrs:{"row":""}}),_c('AppNavigationBottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }